import { catchError, from, map, Observable, tap } from 'rxjs';
import { AxiosError, AxiosResponse } from 'axios';
import { ClientsUnit } from '@store/clients/units/clients-units.model';

import APIAxios, { APIRoutes } from '@api/axios.api';
import SnackError from '@utils/error.utils';
import { clientsUnitsDetailsStore } from '@store/clients/units/details/clients-units-details.store';
import { getClientUnitDetailsDataSource } from '@store/clients/units/details/clients-units-details.requests';

export class ClientsUnitsDetailsService {
  store = clientsUnitsDetailsStore;

  resetStore = () => this.store.reset();

  getClientUnitById = (clientUnitId: number | string): Observable<ClientsUnit> => {
    return from(APIAxios(APIRoutes.GETClientUnitById(clientUnitId)))
      .pipe(
        catchError((err: AxiosError) => {
          throw new SnackError((err.response as any)?.data?.message, 'error');
        }),
        map((response: AxiosResponse<ClientsUnit>) => {
          return response.data;
        }),
        tap((clientUnit) =>
          this.store.update((state) => ({
              ...state,
              ...clientUnit,
            }),
            getClientUnitDetailsDataSource.setSuccess(),
          )
        ),
        getClientUnitDetailsDataSource.trackRequestStatus(),
      );
  };
}

export const clientsUnitsDetailsService = new ClientsUnitsDetailsService();
